import { useState } from "react"

const JobCard = ({ title, location, type, description, style }) => {
  const [expanded, setExpanded] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [formData, setFormData] = useState({  
  name: "",
  email: "",
  contact: "",
  degree: "",
  message: "",
  resume: null, })
  const [formErrors, setFormErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const [submitStatus, setSubmitStatus] = useState(null)

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setFormData({ ...formData, [name]: value });
};


  const validateForm = () => {
    const errors = {}
    if (!formData.name) errors.name = "Name is required"
    if (!formData.email) errors.email = "Email is required"
    return errors
  }

const handleSubmitApplication = async (e) => {
  e.preventDefault();

  const errors = validateForm();
  if (Object.keys(errors).length > 0) {
    setFormErrors(errors);
    return;
  }

  setFormErrors({});
  setLoading(true);

  const formDataToSend = new FormData();
  formDataToSend.append("name", formData.name);
  formDataToSend.append("email", formData.email);
  formDataToSend.append("mobile", formData.mobile); // use "mobile" to match PHP
  formDataToSend.append("degree", formData.degree);
  formDataToSend.append("message", formData.message);
  if (formData.resume) formDataToSend.append("resume", formData.resume);

  try {
    const res = await fetch("https://admin.lumetiq.in/sendCarrer.php", {
      method: "POST",
      body: formDataToSend,
    });
    const data = await res.json();

    setSubmitStatus({ type: data.status, message: data.message });

    if (data.status === "success") {
      setFormData({
        name: "",
        email: "",
        mobile: "",
        degree: "",
        message: "",
        resume: null,
      });
    }
  } catch (err) {
    setSubmitStatus({
      type: "error",
      message: "Network error. Please try again.",
    });
  } finally {
    setLoading(false);
  }
};




  return (
    <>
      {/* --- Job Card --- */}
      <div
        className="card border-0 shadow-sm h-100"
        style={{
          ...style,
          borderRadius: "16px",
          overflow: "hidden",
          transition: "all 0.3s ease",
        }}
      >
        <div className="card-body p-4">
          <h5 className="fw-bold mb-2">{title}</h5>
          <p className="text-muted mb-3">
            <small>
              <span className="d-inline-block me-2">
                <i className="bi bi-geo-alt me-1"></i> {location}
              </span>
              <span className="d-inline-block">
                <i className="bi bi-clock me-1"></i> {type}
              </span>
            </small>
          </p>

          <div
            className="mb-3"
            style={{
              maxHeight: expanded ? "1000px" : "72px",
              overflow: "hidden",
              transition: "max-height 0.3s ease",
            }}
          >
            <p className="mb-0">{description}</p>
          </div>

          <div className="d-flex justify-content-between">
            <div>
              <button
                className="btn btn-link p-0 text-decoration-none"
                onClick={() => setExpanded(!expanded)}
                style={{ color: "#6d28d9" }}
              >
                {expanded ? "Show less" : "Show more"}
              </button>
            </div>
            <div>
              <button
                className="btn btn-link p-0 text-decoration-none"
                style={{ color: "#6d28d9" }}
                onClick={() => setShowPopup(true)}
              >
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* --- Custom Popup --- */}
{showPopup && (
  <div id="popup-overlay">
    <div style={{maxWidth: "600px"}} id="popup-content">
      <h2>Apply For {title}</h2>
      {submitStatus && (
        <div className={`status-message ${submitStatus.type}`}>
          {submitStatus.message}
        </div>
      )}
      <form onSubmit={handleSubmitApplication}>
        <div className="row">
          {/* Name */}
          <div className="col-md-6 form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
            {formErrors.name && <p className="error">{formErrors.name}</p>}
          </div>

          {/* Email */}
          <div className="col-md-6 form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
            {formErrors.email && <p className="error">{formErrors.email}</p>}
          </div>
        </div>

        <div className="row">
          {/* Mobile */}
          <div className="col-md-6 form-group">
            <label htmlFor="mobile">Mobile:</label>
            <input
              type="text"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
            />
            {formErrors.mobile && <p className="error">{formErrors.mobile}</p>}
          </div>

          {/* Highest Degree */}
          <div className="col-md-6 form-group">
            <label htmlFor="degree">Highest Degree:</label>
            <input
              type="text"
              id="degree"
              name="degree"
              value={formData.degree}
              onChange={handleInputChange}
            />
            {formErrors.degree && <p className="error">{formErrors.degree}</p>}
          </div>
        </div>

        {/* Message */}
        <div className="row">
        <div className="col-md-6 form-group">
          <label htmlFor="resume">Upload Resume:</label>
          <input
            type="file"
            id="resume"
            name="resume"
            accept=".pdf,.doc,.docx"
            onChange={(e) =>
              setFormData({ ...formData, resume: e.target.files[0] })
            }
          />
          {formErrors.resume && <p className="error">{formErrors.resume}</p>}
        </div>
        <div className="col-md-6 form-group py-1">
              <label htmlFor="message">Message:</label>
          <input
            id="message"
            name="message"
            value={formData.message}
            onChange={handleInputChange}
          />
          {formErrors.message && <p className="error">{formErrors.message}</p>}
        </div>
        </div>
        <div className="form-group ">
        
        </div>

        

        {/* Buttons */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button className="tp-btn-border" type="submit" disabled={loading}>
            {loading ? "Sending..." : "Apply Now"}
          </button>
          <button
            className="btn1"
            type="button"
            onClick={() => setShowPopup(false)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
)}


    </>
  ) 
}

export default JobCard
